// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MZXG","select":"styles_select__2isVg"};